/*=========================================================================================
  File Name: moduleRecueilState.js
  Description: Recueil Module State
==========================================================================================*/


const state = {
  hasChanges: { steps: []},//false,
  clientId: "",
  dossierId: "",
  commentaireDossier: "",
  derDossier: "",
  alias: "",
  etatCivil: {
    civility: "",
    firstName: "",
    lastName: "",
    birthLastName: "",
    dateOfBirth: "",
    birthCity: "",
    birthState: "",
    birthDeptNum: "",
    birthCountry: "",
    nationality: "",
    isParentIsole: false,
    isAncienCombattant: false,
    isHandicape: false,
  },
  contactInfo: {
    address: "",
    addressComp: "",
    zipCode: "",
    city: "",
    country: "",
    proEmail: "",
    persoEmail: "",
    persoPhone: "",
    proPhone: "",
    cellPhone: "",
    persoPhoneFormatted: "",
    cellPhoneFormatted: "",
    proPhoneFormatted: "",
    cellPhoneCountryVal: "",
    persoPhoneCountryVal: "",
    proPhoneCountryVal: "",
  },
  situationProfessionnelle: {
    socioProCat: "",
    libelle: ""
  },
  residenceFiscale: {
    adresseFiscaleSame: true,
    contactInfo: {
      address: "",
      addressComp: "",
      zipCode: "",
      city: "",
      country: "",
    }
  },
  situationFamiliale: {
    famSituation: "",
    regimeMatrimonial: "",
    regimePacs: "",
    hasConjoint: false,
    hasRegimeMatrimonial: false,
    hasRegimePacs: false,
    conjointEtatCivil: {
      civility: null,
      firstName: "",
      lastName: "",
      birthLastName: "",
      dateOfBirth: "",
      birthCity: "",
      birthState: "",
      birthDeptNum: "",
      birthCountry: "",
      nationality: "",
      isAncienCombattant: false,
      isHandicape: false,
    },
    conjointSituationProfessionnelle: {
      socioProCat: "",
      libelle: ""
    },
    conjointContactInfo: {
      proEmail: "",
      persoEmail: "",
      persoPhone: "",
      proPhone: "",
      cellPhone: "",
      persoPhoneFormatted: "",
      cellPhoneFormatted: "",
      proPhoneFormatted: "",
      cellPhoneCountryVal: "",
      persoPhoneCountryVal: "",
      proPhoneCountryVal: "",
    },
    conjointResidenceFiscale: {
      adresseFiscaleSame: true,
      contactInfo: {
        address: "",
        addressComp: "",
        zipCode: "",
        city: "",
        country: "",
      }
    },
  },
  fiscalite: {
    irppAcquitte: 0,
    ifiAcquitte: 0
  },
  conformite: {
    origineFonds: [],
    objetRelation: [],
    coherenceProfil: null,
    clientPresentRdv: null,
  },
  avantagesMatrimoniaux: {
    attributionBiensCommuns: null,
    auProfitClientAssuranceNonDenouees: "1",
    auProfitConjointAssuranceNonDenouees: "1",
    montantAuProfitClientAssuranceNonDenouees: 0,
    montantAuProfitConjointAssuranceNonDenouees: 0,
    autresBiensClient: null,
    autresBiensConjoint: null,
    avantagesMatrimoniauxCommentaires: "",
    isClausePreciputAuProfitClient: false,
    isClausePreciputAuProfitConjoint: false,
    auProfitClientDonationDernierVivant: false,
    auProfitConjointDonationDernierVivant: false,
    auProfitClientDonationsEntreVifs: 0,
    auProfitConjointDonationsEntreVifs: 0,
    duesParClientBeneficeCommunaute: 0,
    duesParConjointBeneficeCommunaute: 0,
    duesParCommunauteAuClient: 0,
    duesParCommunauteAuConjoint: 0,
    auProfitClientDonationAnterieur: 0,
    auProfitConjointDonationAnterieur: 0,
    auProfitClientLegs: "1",
    auProfitClientLegsMontant: 0,
    auProfitClientLegsUsurfruit: false,
    auProfitConjointLegs: "1",
    auProfitConjointLegsMontant: 0,
    auProfitConjointLegsUsurfruit: false,
    dettesClientEnversConjoint: 0,
    dettesConjointEnversClient: 0,
    auProfitClientCreanceParticipation: 0,
    auProfitConjointCreanceParticipation: 0,
  },
  heritiers: [{}],
  heritiersCommentaires: "",
  liberalites: [],
  actifs: [],
  passifs: [],
  revenus: [],
  charges: [],
  objectifs: [],
  prevoyance: {
    typeClientIndivIncapaciteTemp: "",
    typeClientCollectifIncapaciteTemp: "",
    typeConjointIndivIncapaciteTemp: "",
    typeConjointCollectifIncapaciteTemp: "",

    typeClientIndivIncapacitePerm: "",
    typeClientCollectifIncapacitePerm: "",
    typeConjointIndivIncapacitePerm: "",
    typeConjointCollectifIncapacitePerm: "",

    typeClientIndivIncapacitePermCat: "",
    typeClientCollectifIncapacitePermCat: "",
    typeConjointIndivIncapacitePermCat: "",
    typeConjointCollectifIncapacitePermCat: "",
    renteMensuelleClient: 0,
    renteMensuelleConjoint: 0,
    deces: [],
    incapaciteTemp: [],
    incapacitePerm: []
  }
};

export default state;